<template>
  <div class="login d-flex justify-center align-center">
    <v-card color="pa-4" width="500px" class="">
      <v-card-title
        ><v-icon x-large color="primary" class="mr-3"
          >mdi-account-circle</v-icon
        >
        تسجيل الدخول</v-card-title
      >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="name"
          :counter="10"
          :rules="nameRules"
          label="اسم المستخدم"
          required
        ></v-text-field>

        <v-text-field
          v-model="pwd"
          :rules="pwdRules"
          label="كلمة المرور"
          required
          type="password"
        ></v-text-field>
        <v-btn
          :disabled="!valid"
          color="red accent-3"
          class="mr-4 mt-5"
          width="100%"
          :loading="loading"
          @click="validate"
        >
          تسجيل الدخول
        </v-btn>
      </v-form>
      <v-snackbar
        transition="fade-transition"
        v-model="snackbar"
        :timeout="timeout"
        color="error"
      >
        اسم المستخدم او كلمة المرور غير صحيحة
      </v-snackbar>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      valid: true,
      name: "",
      snackbar: false,
      timeout: 1700,
      nameRules: [
        (v) => !!v || "اسم المستخدم مطلوب",
        (v) =>
          (v && v.length >= 3) || "ادنى حد لاسم المستخدم هو 3",
      ],
      pwd: "",
      pwdRules: [
        (v) => !!v || "كلمة المرور مطلوبة",
        (v) =>
          (v && v.length >= 6) || "ادنى حد لكلمة المرور هو 6",
      ],
      loading: false,
    };
  },
  beforeCreate() {
    if (sessionStorage.getItem("token")) {
      this.$router.push("/").catch(() => {});
    }
  },
  methods: {
    async validate() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        const data = {
          userName: this.name,
          password: this.pwd,
        };
        this.$store.dispatch("login", data).then(() => {
          if (sessionStorage.getItem("token"))
            this.$router.push({ name: "home" });
          else {
            this.loading = false;
            this.snackbar = true;
          }
        });
      }
    },
  },
};
</script>

<style lang="sass">
.login
  height: 80vh
</style>
